module.exports = __webpack_public_path__ + "static/orion360_sdk_logo-d754c60a0590d2b335adb04b9f106cdf.png";